import { getSwappedValues, getTruthyValue } from "@draftkings/sportsbook-common-utils";
import { parseLiveGameState } from "../parseLiveGameState";
import { sportIdMapConfig } from "./config";
import { createTeamsAdditionalScore, getTeamsScore, getScoreLabels, defaultOnServeHandler, createDefaultShortLabel, getHighlitedResultIndex, } from "./helpers";
import { safeString } from "../../helpers";
export const parseScoreboards = ({ sportId, isTeamSwap, gameScore, liveGameState, participants, isLive, }, dictionary) => {
    var _a, _b, _c, _d, _e;
    const { combinedSecondTierScores = [], additionalScores = {}, homeScore, awayScore, isSettlementScore } = getTruthyValue(gameScore, {
        combinedSecondTierScores: [],
        additionalScores: {},
        homeScore: "",
        awayScore: "",
        isSettlementScore: false
    });
    const [team1AdditionalScore, team2AdditionalScore] = createTeamsAdditionalScore(sportId, homeScore, awayScore, additionalScores, isTeamSwap);
    const [team1Score, team2Score] = getTruthyValue((_a = sportIdMapConfig[sportId]) === null || _a === void 0 ? void 0 : _a.getTeamsScoreHandler, getTeamsScore)(combinedSecondTierScores, team1AdditionalScore, team2AdditionalScore);
    const scoreLabels = getTruthyValue((_b = sportIdMapConfig[sportId]) === null || _b === void 0 ? void 0 : _b.getTeamsScoreLabelsHandler, getScoreLabels)(sportId, combinedSecondTierScores, dictionary, homeScore, awayScore);
    const onServeValue = safeString(additionalScores.onServe) || safeString(additionalScores.americanFootballPosession);
    const onServeHandler = getTruthyValue((_c = sportIdMapConfig[sportId]) === null || _c === void 0 ? void 0 : _c.onServeHandler, defaultOnServeHandler);
    const timer = parseLiveGameState(liveGameState);
    const onServe = onServeHandler(onServeValue, "1");
    const updatedParticipants = getTruthyValue(participants, []);
    const [team1NameOnServe, team2NameOnServe] = getSwappedValues(isTeamSwap, onServe, onServeHandler(onServeValue, "2"));
    const updateAdditionalScores = Object.assign(Object.assign({}, additionalScores), { gamePart: getTruthyValue(liveGameState === null || liveGameState === void 0 ? void 0 : liveGameState.gamePart, ""), batting: team1NameOnServe ? dictionary.myBetsDictionary.Top.toLocaleUpperCase() : dictionary.myBetsDictionary.Bot });
    const createSoreboardShortLabelHandler = ((_d = sportIdMapConfig[sportId]) === null || _d === void 0 ? void 0 : _d.createShortLabelHandler) || createDefaultShortLabel;
    const highlightedIndex = getHighlitedResultIndex(team1Score.length, getTruthyValue((_e = sportIdMapConfig[sportId]) === null || _e === void 0 ? void 0 : _e.decreaseIndexResult, 1));
    return !isSettlementScore ? {
        scoreLabels,
        team1Score: {
            scores: team1Score,
            onServe: team1NameOnServe
        },
        team2Score: {
            scores: team2Score,
            onServe: team2NameOnServe
        },
        timer,
        highlightedIndex,
        shortLabel: isLive ? createSoreboardShortLabelHandler(updateAdditionalScores, dictionary, timer, updatedParticipants) : "",
    } : {
        scoreLabels,
        team1Score: {
            scores: team1Score,
            onServe: false
        },
        team2Score: {
            scores: team2Score,
            onServe: false
        },
        timer,
        highlightedIndex,
        shortLabel: dictionary.myBetsDictionary.FinalScore,
    };
};
//# sourceMappingURL=parseScoreboards.js.map